import axiosInstance from "../../../api/axiosInstance";

let postPlatform = async(props) => {
    let formulary = {
        nombrePlataforma: props.nombrePlataforma,
        paisPlataforma: props.paisPlataforma,
        domicilioPlataforma: props.domicilioPlataforma,
        ciudadPlataforma: props.ciudadPlataforma,
    };

    return new Promise((resolve, reject) => {   
        axiosInstance.post(process.env.REACT_APP_API + "/functions/solicitud", formulary)
        .then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}

export default postPlatform